const getVisibleEquipmentsByAccountIDUsecase = (repository) => async (id) => {
    return await repository(id);
}

export default getVisibleEquipmentsByAccountIDUsecase;